import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ff9e7b4a&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=ff9e7b4a&prod&scoped=true&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=ff9e7b4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9e7b4a",
  null
  
)

export default component.exports